<template>
  <div class="homes">
      <aboutStyle title="联系我们"></aboutStyle>
      <el-row class="el-row">
      <el-col :span="11">
        <div class="grid-content">
          <el-divider content-position="left"><span style="color:#015EB7">公司地图</span></el-divider>
          <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:400px" @click="getClickInfo">
          <bm-marker :position="{lng: center.lng, lat: center.lat}"></bm-marker>
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>

          <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
          <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
          <bm-info-window :position="{lng: center.lng, lat: center.lat}" :title="companyInfo.companyName" :show="true" @close="infoWindowClose" @open="infoWindowOpen">
             <p><span class="left" style="font-size:13px">公司地址:</span><span class="right" style="font-size:13px">{{companyInfo.companyAddress}}</span></p>
          </bm-info-window>
          <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>

        </baidu-map>
        </div></el-col>
      <el-col :span="2">
        <div class="grid-content">
        </div>
      </el-col>    
      <el-col :span="11">
          <div class="grid-content">
            <el-divider content-position="left"><span style="color:#015EB7">商务咨询</span></el-divider>
              <el-form ref="rootMenuForm" :rules="rules" :model="form" label-width="80px">
                <el-form-item label="姓名" prop="userName">
                    <el-input v-model="form.userName" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
               <el-form-item label="电话" prop="contactMethod">
                    <el-input v-model="form.contactMethod" placeholder="请输入联系电话" clearable></el-input>
                </el-form-item>
               <el-form-item label="公司名称">
                    <el-input v-model="form.companyName" placeholder="请输入公司名称" clearable></el-input>
                </el-form-item>                
               <el-form-item label="咨询内容" prop="contactContent">
                    <el-input  type="textarea" v-model="form.contactContent" :rows="7" maxlength="150" resize="none" clearable show-word-limit placeholder="请输入咨询内容"></el-input>
                </el-form-item>                
                <el-row>
                   <el-col :span="24">
                    <div class="grid-content btn">
                        <el-button type="primary" @click="submitInfoClick">去咨询</el-button>
                    </div>
                  </el-col>
                </el-row>  
              </el-form>
          </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import aboutStyle from '@/components/aboutStyle.vue';
export default {
  components:{ aboutStyle},
  data(){
    return {
      urls:'/api/admin/about/select_page',
      title:'aboutTitle',
      content:'aboutContent',
      form:{},
      center: {lng:0, lat:0},
      zoom:13,
      companyInfo:{},
      rules:{
         userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
         contactMethod: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
         contactContent: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      }
    }
  },
  mounted() {
      this.getCompanyInfo()      
  },
  methods:{
    handler ({BMap, map}){
      console.log(BMap, map)
      //114.075262,22.540082
      //鸿瑞芯公司定位113.928451,22.778482
      this.center.lng =113.928451
      this.center.lat =22.778482
      this.getCompanyInfo();
      },
    getClickInfo (e) {
      this.center.lng = e.point.lng
      this.center.lat = e.point.lat
    },
    getCompanyInfo(){
      this.companyInfo =JSON.parse( localStorage.getItem("companyInfo"));
      this.center.lng = this.companyInfo.lng
      this.center.lat = this.companyInfo.lat
    },
    submitInfoClick(){
      //   //提交
      this.$refs.rootMenuForm.validate(valid => {
        if (valid) {
            this.$api.formPost("/api/web/submit_info", this.form).then((res) => {
              if(res.code != 1){
                  this.$message.error(res.message)
              }else{
                this.$message.success('提交成功,请等待工作人员的回馈')
              }
            }).catch((res) => {
              console.error(res)
            })
        }
      })

    }

  }  
}
</script>
<style lang="less" scoped>
  .homes{
    height: calc(~"100% - 20px");
  .el-row{
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .bg-purple {
    background: #d3dce6;
  }  
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    min-height: 36px;
  }
  .btn{
     display: flex;
    justify-items: center;
    justify-content: center;
    align-items: center;
  }
  .bm-view {
    width:100%;
    height:200px;
  }
  
  }
</style>